import { render, staticRenderFns } from "./platformActivity.vue?vue&type=template&id=63202f5f&scoped=true&"
import script from "./platformActivity.vue?vue&type=script&lang=js&"
export * from "./platformActivity.vue?vue&type=script&lang=js&"
import style0 from "./platformActivity.vue?vue&type=style&index=0&id=63202f5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63202f5f",
  null
  
)

export default component.exports